import BaseDialog from '@/components/BaseDialog'
// import BaseDrawer from '@/components/BaseDrawer'

// 批量导入
export function batchImportModal({ props, cbs, title  }) {
    return new BaseDialog({
        component: ()=>import('./batchImportModal'),
        options: {
            width: '900px',
            title: `批量添加产品KPI`,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
